<template lang="pug">
  tbody
    tr
      th(colspan=2) {{ livecasino_title }}
      td
        PTSelect(
          ref="livecasino_upline_pt"
          :dirty="$v.livecasino_upline_pt.$dirty"
          :error="$v.livecasino_upline_pt.$error"
          :options="livecasino_upline_options"
          :value="livecasino_upline_pt"
          @input="input_livecasino_upline_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="livecasino_account_pt"
          :dirty="$v.livecasino_account_pt.$dirty"
          :error="$v.livecasino_account_pt.$error"
          :options="livecasino_account_options"
          :value="livecasino_account_pt"
          @input="input_livecasino_account_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="livecasino_upline_remaining"
          :dirty="$v.livecasino_upline_remaining.$dirty"
          :error="$v.livecasino_upline_remaining.$error"
          :options="livecasino_account_options"
          :value="livecasino_upline_remaining"
          @input="$v.livecasino_upline_remaining.$model = $event"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="livecasino_account_min"
          :dirty="$v.livecasino_account_min.$dirty"
          :error="$v.livecasino_account_min.$error"
          :options="livecasino_min_options"
          :value="livecasino_account_min"
          @input="$v.livecasino_account_min.$model = $event"
          :disabled="loading"
        )
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import PTSelect from "@/library/PTSelect";

export default {
  components: {
    PTSelect
  },
  props: {
    loading: false,
    accountID: ""
  },
  data() {
    return {
      livecasino_upline_pt: 0,
      livecasino_account_pt: 0,
      livecasino_upline_remaining: 0,
      livecasino_account_min: 0
    }
  },
  validations() {
    return {
      livecasino_upline_pt: {
        required,
        minValue(value) {
          if(this.$helpers.isPlatformEnabled('LC')) {
            let total = 0
            if(this.$helpers.isAgentLevel()) {
              total = value
            } else {
              total = value + this.livecasino_account_pt
            }
            if(total < this.livecasino_upline_min) {
              return false
            } else {
              return true
            }
          } else {
            return true
          }
        }
      },
      livecasino_account_pt: {
        required,
        minValue(value) {
          if(this.$helpers.isPlatformEnabled('LC')) {
            let total = 0
            if(this.$helpers.isAgentLevel()) {
              return true
            } else {
              total = value + this.livecasino_upline_pt
              if(total < this.livecasino_upline_min) {
                return false
              } else {
                return true
              }
            }
          } else {
            return true
          }
        }
      },
      livecasino_upline_remaining: {
        required
      },
      livecasino_account_min: {
        required
      }
    }
  },
  computed: {
    isSearch: function() {
      if(this.accountID) {
        return !(this.accountID.length > 8)
      } else {
        return !this.$helpers.isAgentLevel()
      }
    },
    livecasino_title: function () {
      return this.$t("ui.live_casino") + " (" + this.livecasino_upline_min + "%-" + this.livecasino_upline_max + "%)"
    },
    livecasino_upline_min: function() {
      return this.$store.getters.getPTLC[0].account_min
    },
    livecasino_upline_max: function() {
      return this.$store.getters.getPTLC[0].account_pt
    },
    livecasino_account_max: function() {
      return this.livecasino_upline_max - this.livecasino_upline_pt
    },
    livecasino_upline_options: function() {
      return this.$helpers.getPTRateList(this.livecasino_upline_max)
    },
    livecasino_account_options: function() {
      return this.$helpers.getPTRateList(this.livecasino_account_max)
    },
    livecasino_min_options: function() {
      return this.$helpers.getPTRateList(this.livecasino_account_pt)
    }
  },
  mounted: function() {
    if(this.$helpers.isAgentLevel()) {
      this.$v.livecasino_upline_pt.$model = this.livecasino_upline_max
    }
    if(!this.$helpers.isPlatformEnabled('LC')) {
      this.$v.livecasino_upline_pt.$model = this.livecasino_upline_min
    }
  },
  methods: {
    input_livecasino_upline_pt(e) {
      this.$v.livecasino_upline_pt.$model = e
      this.$v.livecasino_account_pt.$model = this.livecasino_account_max

      if (this.livecasino_upline_remaining > this.livecasino_account_max) {
        this.$v.livecasino_upline_remaining.$model = 0
      }
      if (this.livecasino_account_min > this.livecasino_account_pt) {
        this.$v.livecasino_account_min.$model = 0
      }
    },
    input_livecasino_account_pt(e) {
      this.$v.livecasino_account_pt.$model = e
      if (this.livecasino_account_min > this.livecasino_account_pt) {
        this.$v.livecasino_account_min.$model = 0
      }
    }
  }
}

</script>